import React, { useState } from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Input,
} from "@nextui-org/react"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { setLogin } from "../../state/authSlice"
import { useDispatch } from "react-redux"
import { ToastContainer } from "react-toastify"
import { usePost } from "../../api/reactQueryCustomHooks"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "react-toastify/dist/ReactToastify.css" //react toastify css

function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  })

  const resetValues = () => {
    setFormData({
      username: "",
      password: "",
    })
  }

  const onSuccessTasks = (data) => {
    navigate(linksUrl.clientMaster.read)
    dispatch(
      setLogin({
        admin: data.admin,
        token: data.accessToken,
        refreshToken: data.refreshToken,
      })
    )
  }

  const { isPending, mutate: login } = usePost({
    url: apiRoute.adminMaster.login,
    queryKey: "auth",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Validate the form before submission
    if (validateForm()) {
      // Perform form submission logic here
      login({
        data: {
          username: formData.username,
          password: formData.password,
        },
      })
    } else {
      console.log("Form has errors. Please fix them.")
    }
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate username
    if (formData.username.trim() === "") {
      newErrors.username = "Client Code is required"
    }

    // Validate password
    if (formData.password.trim() === "") {
      newErrors.password = "Password is required"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  return (
    <div className="flex items-center justify-center mt-20">
      <ToastContainer />

      <Card className="max-w-[600px]">
        <CardHeader className="flex justify-center">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 dark:text-white text-center">
            Login
          </h1>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardBody>
            <div className="flex flex-col gap-4 mx-2">
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="Username"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.username}
                  errorMessage={errors?.username}
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  label="Password"
                  labelPlacement="outside"
                  placeholder="Enter your password"
                  name="password"
                  isInvalid={errors?.password}
                  errorMessage={errors?.password}
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                  className="max-w-xs"
                />
              </div>
            </div>
          </CardBody>
          <CardFooter className="flex justify-center">
            <Button color="primary" type="submit" isLoading={isPending}>
              Login
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  )
}

export default Login
